const invalidBearerTokenError = [ 'InvalidBearerTokenError', 'InvalidTokenError' ];

const isInvalidTokenError = (errorOrDetail) => {
    const data = errorOrDetail?.data ?? errorOrDetail;

    return data?.errors?.some((e) =>
        invalidBearerTokenError.includes(e.type) ||
        invalidBearerTokenError.includes(e.code)
    );
};

export default isInvalidTokenError;
